import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import { APP_FILE_CSIO_CRON } from "./csioCron.constants";

const CsioCron = Loadable(
  lazy(() =>
    import("./CSIOCronList").then(({ CSIOCronList }) => ({
      default: CSIOCronList,
    }))
  )
);
export const csioCronRoutes = [
  {
        path: `${APP_FILE_CSIO_CRON}`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.CSIO_CRON]}>
            <CsioCron />
          </AuthorizedRoute>
        ),
      },

];
